/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AhriHeatPumpCompressorStaging } from '../models/AhriHeatPumpCompressorStaging';
import type { AhriHeatPumpDuctType } from '../models/AhriHeatPumpDuctType';
import type { AhriHeatPumpFanType } from '../models/AhriHeatPumpFanType';
import type { AhriHeatPumpIndoorType } from '../models/AhriHeatPumpIndoorType';
import type { AhriHeatPumpSystemType } from '../models/AhriHeatPumpSystemType';
import type { AttachContractorsEquipmentsRequest } from '../models/AttachContractorsEquipmentsRequest';
import type { EnergyStarWaterHeaterType } from '../models/EnergyStarWaterHeaterType';
import type { EquipmentCreateCatalogRequest } from '../models/EquipmentCreateCatalogRequest';
import type { EquipmentEvaporativeCoolerOptions } from '../models/EquipmentEvaporativeCoolerOptions';
import type { EquipmentFilter } from '../models/EquipmentFilter';
import type { EquipmentFilterResponse } from '../models/EquipmentFilterResponse';
import type { EquipmentHeatPumpOptions } from '../models/EquipmentHeatPumpOptions';
import type { EquipmentPreferenceRequest } from '../models/EquipmentPreferenceRequest';
import type { EquipmentPreferenceResponse } from '../models/EquipmentPreferenceResponse';
import type { EquipmentResponse } from '../models/EquipmentResponse';
import type { EquipmentUpdateRequest } from '../models/EquipmentUpdateRequest';
import type { EquipmentWaterHeaterFirstHourRatingOptions } from '../models/EquipmentWaterHeaterFirstHourRatingOptions';
import type { EquipmentWaterHeaterStorageVolumeGallonsOptions } from '../models/EquipmentWaterHeaterStorageVolumeGallonsOptions';
import type { FilterItem_str_ } from '../models/FilterItem_str_';
import type { JobServiceEquipment } from '../models/JobServiceEquipment';
import type { PaginatedResponse_EquipmentEvaporativeCoolerResponse_ } from '../models/PaginatedResponse_EquipmentEvaporativeCoolerResponse_';
import type { PaginatedResponse_EquipmentHeatPumpResponse_ } from '../models/PaginatedResponse_EquipmentHeatPumpResponse_';
import type { PaginatedResponse_EquipmentVentFanResponse_ } from '../models/PaginatedResponse_EquipmentVentFanResponse_';
import type { PaginatedResponse_EquipmentWaterHeaterResponse_ } from '../models/PaginatedResponse_EquipmentWaterHeaterResponse_';
import type { Programs } from '../models/Programs';
import type { VentilatingFanType } from '../models/VentilatingFanType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EquipmentRoutesRepository {
  /**
   * Get Heat Pumps
   * Get heat pumps.
   * @returns PaginatedResponse_EquipmentHeatPumpResponse_ Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetHeatPumps({
    includeEligibility = false,
    includePreferred = false,
    ahriId,
    outdoorUnitModelNumber,
    indoorUnitModelNumber,
    furnaceModelNumber,
    outdoorUnitBrandName,
    seriesName,
    tons,
    seerGte,
    indoorType,
    systemType,
    fanType,
    ductType,
    compressorStaging,
    hasFurnace,
    isLabeledEnergyStar,
    meetsEnergyStarColdClimateSpecs,
    isActive,
    preferredForContractorId,
    programKey,
    pageNumber = 1,
    perPage = 10,
    authorization,
  }: {
    includeEligibility?: boolean,
    includePreferred?: boolean,
    ahriId?: (string | null),
    outdoorUnitModelNumber?: (string | null),
    indoorUnitModelNumber?: (string | null),
    furnaceModelNumber?: (string | null),
    outdoorUnitBrandName?: (string | null),
    seriesName?: (string | null),
    tons?: (number | null),
    seerGte?: (number | null),
    indoorType?: (AhriHeatPumpIndoorType | null),
    systemType?: (Array<AhriHeatPumpSystemType> | null),
    fanType?: (Array<AhriHeatPumpFanType> | null),
    ductType?: (Array<AhriHeatPumpDuctType> | null),
    compressorStaging?: (Array<AhriHeatPumpCompressorStaging> | null),
    hasFurnace?: (boolean | null),
    isLabeledEnergyStar?: (boolean | null),
    meetsEnergyStarColdClimateSpecs?: (boolean | null),
    isActive?: (boolean | null),
    preferredForContractorId?: (string | null),
    programKey?: (Programs | null),
    pageNumber?: number,
    perPage?: number,
    authorization?: string,
  }): CancelablePromise<PaginatedResponse_EquipmentHeatPumpResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/heat-pumps',
      headers: {
        'authorization': authorization,
      },
      query: {
        'include_eligibility': includeEligibility,
        'include_preferred': includePreferred,
        'ahri_id': ahriId,
        'outdoor_unit_model_number': outdoorUnitModelNumber,
        'indoor_unit_model_number': indoorUnitModelNumber,
        'furnace_model_number': furnaceModelNumber,
        'outdoor_unit_brand_name': outdoorUnitBrandName,
        'series_name': seriesName,
        'tons': tons,
        'seer_gte': seerGte,
        'indoor_type': indoorType,
        'system_type': systemType,
        'fan_type': fanType,
        'duct_type': ductType,
        'compressor_staging': compressorStaging,
        'has_furnace': hasFurnace,
        'is_labeled_energy_star': isLabeledEnergyStar,
        'meets_energy_star_cold_climate_specs': meetsEnergyStarColdClimateSpecs,
        'is_active': isActive,
        'preferred_for_contractor_id': preferredForContractorId,
        'program_key': programKey,
        'page_number': pageNumber,
        'per_page': perPage,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Water Heaters
   * Get water heaters.
   * @returns PaginatedResponse_EquipmentWaterHeaterResponse_ Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetWaterHeaters({
    includePreferred = false,
    includeEligibility = false,
    energyStarUniqueId,
    brandName,
    modelNumber,
    storageVolumeGallons,
    firstHourRating,
    waterHeaterType,
    preferredForContractorId,
    programKey,
    pageNumber = 1,
    perPage = 10,
    authorization,
  }: {
    includePreferred?: boolean,
    includeEligibility?: boolean,
    energyStarUniqueId?: (number | null),
    brandName?: (string | null),
    modelNumber?: (string | null),
    storageVolumeGallons?: (EquipmentWaterHeaterStorageVolumeGallonsOptions | null),
    firstHourRating?: (EquipmentWaterHeaterFirstHourRatingOptions | null),
    waterHeaterType?: (Array<EnergyStarWaterHeaterType> | null),
    preferredForContractorId?: (string | null),
    programKey?: (Programs | null),
    pageNumber?: number,
    perPage?: number,
    authorization?: string,
  }): CancelablePromise<PaginatedResponse_EquipmentWaterHeaterResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/water-heaters',
      headers: {
        'authorization': authorization,
      },
      query: {
        'include_preferred': includePreferred,
        'include_eligibility': includeEligibility,
        'energy_star_unique_id': energyStarUniqueId,
        'brand_name': brandName,
        'model_number': modelNumber,
        'storage_volume_gallons': storageVolumeGallons,
        'first_hour_rating': firstHourRating,
        'water_heater_type': waterHeaterType,
        'preferred_for_contractor_id': preferredForContractorId,
        'program_key': programKey,
        'page_number': pageNumber,
        'per_page': perPage,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Evaporative Coolers
   * Get evaporative coolers.
   * @returns PaginatedResponse_EquipmentEvaporativeCoolerResponse_ Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetEvaporativeCoolers({
    brandName,
    modelNumber,
    modelName,
    pageNumber = 1,
    perPage = 10,
    authorization,
  }: {
    brandName?: (string | null),
    modelNumber?: (string | null),
    modelName?: (string | null),
    pageNumber?: number,
    perPage?: number,
    authorization?: string,
  }): CancelablePromise<PaginatedResponse_EquipmentEvaporativeCoolerResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/evaporative-coolers',
      headers: {
        'authorization': authorization,
      },
      query: {
        'brand_name': brandName,
        'model_number': modelNumber,
        'model_name': modelName,
        'page_number': pageNumber,
        'per_page': perPage,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Vent Fans
   * Get ventilating fans.
   * @returns PaginatedResponse_EquipmentVentFanResponse_ Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetVentFans({
    brandName,
    modelNumber,
    energyStarPartner,
    ventFanType,
    pageNumber = 1,
    perPage = 10,
    authorization,
  }: {
    brandName?: (string | null),
    modelNumber?: (string | null),
    energyStarPartner?: (string | null),
    ventFanType?: (VentilatingFanType | null),
    pageNumber?: number,
    perPage?: number,
    authorization?: string,
  }): CancelablePromise<PaginatedResponse_EquipmentVentFanResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/vent-fans',
      headers: {
        'authorization': authorization,
      },
      query: {
        'brand_name': brandName,
        'model_number': modelNumber,
        'energy_star_partner': energyStarPartner,
        'vent_fan_type': ventFanType,
        'page_number': pageNumber,
        'per_page': perPage,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Fetch All Equipment
   * Get all equipment.
   * @returns EquipmentResponse Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesFetchAllEquipment({
    requestBody,
    authorization,
  }: {
    requestBody: EquipmentFilter,
    authorization?: string,
  }): CancelablePromise<Array<EquipmentResponse>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/equipment/fetch',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Equipment Filters
   * Get equipment filters.
   * @returns EquipmentFilterResponse Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetEquipmentFilters({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<EquipmentFilterResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/filters',
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Equipment Manufacturers
   * Get manufacturer filter options given the equipment type.
   *
   * If user is contractor, only return manufacturers that are linked to the contractor.
   * if user is internal, only return manufacturers that are linked to the contractor associated with the job.
   * @returns FilterItem_str_ Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetEquipmentManufacturers({
    equipmentType,
    jobId,
    authorization,
  }: {
    equipmentType: JobServiceEquipment,
    jobId: string,
    authorization?: string,
  }): CancelablePromise<Array<FilterItem_str_>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/manufacturers/{equipment_type}/{job_id}',
      path: {
        'equipment_type': equipmentType,
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Heat Pump Outdoor Unit Brand Names
   * Get distinct heat pump outdoor unit brand names.
   * @returns FilterItem_str_ Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetHeatPumpOutdoorUnitBrandNames({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<Array<FilterItem_str_>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/heat-pump/outdoor-unit-brand-names',
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Heat Pump Options
   * Get distinct heat pump options for series_name and tons given a outdoor unit brand name.
   * @returns EquipmentHeatPumpOptions Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetHeatPumpOptions({
    outdoorUnitBrandName,
    authorization,
  }: {
    outdoorUnitBrandName: string,
    authorization?: string,
  }): CancelablePromise<EquipmentHeatPumpOptions> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/heat-pump/outdoor-unit-brand-names/{outdoor_unit_brand_name}',
      path: {
        'outdoor_unit_brand_name': outdoorUnitBrandName,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Water Heater Brand Names
   * Get distinct water heater brand names.
   * @returns FilterItem_str_ Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetWaterHeaterBrandNames({
    energyStarWaterHeaterTypes,
    authorization,
  }: {
    energyStarWaterHeaterTypes: Array<EnergyStarWaterHeaterType>,
    authorization?: string,
  }): CancelablePromise<Array<FilterItem_str_>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/water-heater/brand-names',
      headers: {
        'authorization': authorization,
      },
      query: {
        'energy_star_water_heater_types': energyStarWaterHeaterTypes,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Water Heater Model Number Options
   * Get distinct water heater options for model number given a brand name.
   * @returns FilterItem_str_ Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetWaterHeaterModelNumberOptions({
    brandName,
    energyStarWaterHeaterTypes,
    authorization,
  }: {
    brandName: string,
    energyStarWaterHeaterTypes: Array<EnergyStarWaterHeaterType>,
    authorization?: string,
  }): CancelablePromise<Array<FilterItem_str_>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/water-heater/brand-names/{brand_name}',
      path: {
        'brand_name': brandName,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'energy_star_water_heater_types': energyStarWaterHeaterTypes,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Prefer Equipment
   * Prefer equipment for a contractor.
   * @returns EquipmentPreferenceResponse Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesPreferEquipment({
    requestBody,
    authorization,
  }: {
    requestBody: EquipmentPreferenceRequest,
    authorization?: string,
  }): CancelablePromise<EquipmentPreferenceResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/equipment/prefer',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Equipment
   * Get equipment by id.
   * @returns EquipmentResponse Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetEquipment({
    equipmentId,
    authorization,
  }: {
    equipmentId: string,
    authorization?: string,
  }): CancelablePromise<EquipmentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/{equipment_id}',
      path: {
        'equipment_id': equipmentId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Equipment
   * Update equipment.
   * @returns EquipmentResponse Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesUpdateEquipment({
    equipmentId,
    requestBody,
    authorization,
  }: {
    equipmentId: string,
    requestBody: EquipmentUpdateRequest,
    authorization?: string,
  }): CancelablePromise<EquipmentResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/equipment/{equipment_id}',
      path: {
        'equipment_id': equipmentId,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Equipment
   * Delete equipment.
   * @returns void
   * @throws ApiError
   */
  public static equipmentRoutesDeleteEquipment({
    equipmentId,
    authorization,
  }: {
    equipmentId: string,
    authorization?: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/equipment/{equipment_id}',
      path: {
        'equipment_id': equipmentId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Attach Multiple
   * Attach multiple equipments to multiple contractors.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesAttachMultiple({
    requestBody,
    authorization,
  }: {
    requestBody: AttachContractorsEquipmentsRequest,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/equipment/attach/multiple',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Equipment Catalog
   * Create equipment with efficiency/capacity info from catalog form.
   * @returns EquipmentResponse Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesCreateEquipmentCatalog({
    requestBody,
    authorization,
  }: {
    requestBody: EquipmentCreateCatalogRequest,
    authorization?: string,
  }): CancelablePromise<EquipmentResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/equipment/create/catalog',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Multiple Equipments
   * Delete multiple equipments.
   * @returns void
   * @throws ApiError
   */
  public static equipmentRoutesDeleteMultipleEquipments({
    requestBody,
    authorization,
  }: {
    requestBody: Array<string>,
    authorization?: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/equipment',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Merge Equipments
   * Merge equipments.
   * @returns EquipmentResponse Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesMergeEquipments({
    equipmentId,
    requestBody,
    authorization,
  }: {
    equipmentId: string,
    requestBody: Array<string>,
    authorization?: string,
  }): CancelablePromise<EquipmentResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/equipment/merge/{equipment_id}',
      path: {
        'equipment_id': equipmentId,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Evaporative Coolers Brand Names
   * Get distinct evaporative cooler brand names.
   * @returns FilterItem_str_ Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetEvaporativeCoolersBrandNames({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<Array<FilterItem_str_>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/evaporative-coolers/brand-names',
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Evaporative Cooler Model Options
   * Get distinct evaporative cooler model names.
   * @returns EquipmentEvaporativeCoolerOptions Successful Response
   * @throws ApiError
   */
  public static equipmentRoutesGetEvaporativeCoolerModelOptions({
    brandName,
    authorization,
  }: {
    brandName: string,
    authorization?: string,
  }): CancelablePromise<EquipmentEvaporativeCoolerOptions> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/equipment/evaporative-coolers/brand-names/{brand-name}',
      headers: {
        'authorization': authorization,
      },
      query: {
        'brand_name': brandName,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
